<div>
    <div *ngIf="walletProfile" class="font-semibold text-xl mb-5 inline-flex justify-start items-center gap-x-2 cursor-pointer" backButton>
        <span nz-icon nzType="antd:v2-back" class="text-2xl"></span>
        <span class="truncate"> {{ (commonService.getAddrName(walletProfile)) | omit:omitLength:omitLength }}</span>
        <span>'s {{ type === 'following' ? 'Followings' : 'Followers' }}</span>
    </div>

    <!-- Follower List -->
    <ng-container *ngIf="type === 'follower'">
        <div class="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
            <app-user-card [gradientCard]="true" [userInfo]="item" *ngFor="let item of data"></app-user-card>
        </div>
    </ng-container>

    <ng-container *ngIf="type === 'following' && walletProfile">
        <!-- Following List -->
        <div class="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
            <app-user-card [gradientCard]="true" [userInfo]="item" *ngFor="let item of data"></app-user-card>
        </div>
    </ng-container>

    <div *ngIf="data?.length && !isLastPage" class="flex justify-center py-10" appScrollObserver (scrolledIntoView)="loadData()">
        <div appLoading [loading]="true" class="w-10 h-10 loading-icon"></div>
    </div>

    <nz-skeleton *ngIf="!data" [nzActive]="true"></nz-skeleton>

    <div *ngIf="data?.length === 0" class="flex flex-col justify-start items-center text-[#b5b5b5]">
        <img src="/assets/imgs/no-data/no-data.png" alt="No Data " class="w-36" />
        <div>No {{ type === 'following' ? 'Following' : 'Follower' }}</div>
    </div>
</div>
